import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { take } from 'rxjs/operators';

import { BaseComponents } from '../base.component';

// reCAPTCHA v3 action the server checks before issuing a new reference (recaptcha-verifier).
const RECAPTCHA_ACTION = 'buyonline_reference';

@Injectable()
export class GenInsuranceTransactionNumberService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService, 
    //private logger: NGXLogger
  ) {
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if(this.VERIFY_TOKEN_EXPIRE){
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any) {
    const url = `${environment.endpointBackend}/api/services/buy-insurance/reference1`;
    const body = this.input(param);
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // A new reference needs a reCAPTCHA v3 token; without one the server refuses the request.
  private recaptchaToken(): Promise<string | null> {
    return this.injectorObj.get(ReCaptchaV3Service).execute(RECAPTCHA_ACTION)
      .pipe(take(1))
      .toPromise()
      .catch(() => null);
  }

  // Core Function ! No modify
  async exec(param: any) {
    const self = this;
    const recaptchaToken = await this.recaptchaToken();
    return new Promise(function(resolve, reject) {
      if(!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()){
        self.connector({ ...param, recaptchaToken }).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            resolve(self.output(res['body']));
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus:  401,
          message: 'token is expired'
        });
      }
    });
  }
}
